<template>
  <div
    id="otp_modal"
    class="modal modal-lg animate__animated animate__zoomIn animate__faster"
    style="margin-top:80px;margin-left:100px;margin-right"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <!-- <button
type="button"
class="btn-close"
data-bs-dismiss="modal"
aria-label="Close"
></button> -->
        </div>

        <div class="modal-body p-4">
          <div class="form-header">
            <h2>Enter OTP</h2>
            <p>
              To continue, we'll require you to input your OTP to authorize this
              login.
            </p>
            <p>
              Enter the six-digit OTP sent to the patient email or phone number
              asssociated with your account, to proceed.
            </p>
          </div>
          <!-- body starts here -->
          <div class="row">
            <div class="col-3"></div>
            <div class="col-6">
              <div
                id="otp-input-container"
                style="
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  justify-content: center;
                "
              >
                <!-- OTP input fields will be dynamically added here using JavaScript -->
              </div>
            </div>
            <div class="col-3"></div>
          </div>
          <br />
          <br />

          <div class="row" style="align-items: center; justify-content: center">
            <div class="col-4">
              <span>
                Didn't get code?
                <span class="special-color xvx">Resend</span></span
              >
            </div>
            <div class="col-4 text-center" style="text-align: center">
              <span id="errormsg"></span>
            </div>
            <div class="col-4 text-right" style="text-align: right">
              <span class="special-color"
                >Expires in
                <span class="count-down" id="count-down">5:00</span></span
              >
            </div>
          </div>

          <!-- /.modal -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapActions } from "vuex";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { ApiResponseCodes } from "@/utils/response_codes";

export default {
  name: "Settings_menu",
  data() {
    return {
    
      otp: null,
    };
  },

  methods: {
     ...mapActions({
      _verify: "general/verify",
    }),
    viewDashboard() {
      if (this.selectedStoreId) {
        localStorage.setItem("store_id", this.selectedStoreId);
      }
      window.location = "/dashboard/sales-dashboard";
    },
  },
  mounted() {
    const otpInputContainer = document.getElementById("otp-input-container");

    // Function to create OTP input fields
    function createOTPInputFields(length) {
      otpInputContainer.innerHTML = ""; // Clear previous input fields

      for (let i = 0; i < length; i++) {
        const input = document.createElement("input");
        input.type = "text";
        input.maxLength = 1;
        input.classList.add("otp-input");
        input.addEventListener("input", handleInput);
        input.placeholder = "-";
        input.pattern = "[0-9]*";
        input.style =
          "height:60px; width:60px;margin:0 5px;font-size:19px;text-align:center";
        // input.style:focus="border-color: #007bff;outline: none;"
        input.addEventListener("input", handleInput);
        input.addEventListener("keydown", handleKeyDown);

        otpInputContainer.appendChild(input);
      }
    }

    // Handle input in OTP fields
    function handleInput() {
      const inputs = Array.from(
        otpInputContainer.getElementsByTagName("input")
      );

      for (let i = 0; i < inputs.length; i++) {
        if (inputs[i].value && i < inputs.length - 1) {
          inputs[i + 1].focus();
        }
      }
    }

    // Set the length of OTP (customize this according to your needs)
    const otpLength = 6;
    createOTPInputFields(otpLength);

    // Focus on the first OTP input field
    const firstInput = otpInputContainer.getElementsByTagName("input")[0];
    if (firstInput) {
      firstInput.focus();
    }

    const _vm = this;

    function handleInput() {
      const inputs = Array.from(
        otpInputContainer.getElementsByTagName("input")
      );
      const lastInput = inputs[inputs.length - 1];

      // Check if the last input is filled
      if (lastInput.value) {
        // Perform the action when the last input is filled
        this.otp = Array.from(otpInputContainer.getElementsByTagName("input"))
          .map((input) => input.value)
          .join("");

        // alert(this.otp);
        // alert(_vm.patient_id);
        // alert();

        // api call
        $(".inloader").show();

        _vm
          ._verify({
            platform: "Web",
            code: this.otp,
          })
          .then((response) => {
            $(".inloader").hide();
            toast.success("Login successful", {
              position: toast.POSITION.TOP_RIGHT,
            });
            _vm.response = response.data;
              var data = _vm.response;
              var token = data.token;
              const profile = data.data;
              localStorage.setItem("accessToken", token);
              localStorage.setItem("data", JSON.stringify(profile));

              $("#otp_modal").modal("hide");
              if (response.data.code == ApiResponseCodes.SEND_STORE_ID) {
                _vm.stores = profile.stores.map((store) => ({
                  id: store.id,
                  text: store.name,
                }));
                _vm.needs2SelectStore = true;
                _vm.showDashboardBtn = true;
              } else {
                _vm.viewDashboard();
              }
          })
          .catch((error) => {
            $(".inloader").hide();
            console.log(error);
            // _vm.$toast.error();
            // $("#errormsg").text(error.response.data.message);
            $(".inloader").hide();
            // $("#otp_modal").modal("hide")
            _vm.otp = "";

            // could be removed
            if (error.response) {
              const status = error.response.status;
              const data = error.response.data;
              // localStorage.setItem("email", data.email);
              if (
                status == 400 ||
                status == 422 ||
                status == 401 ||
                status == 404
              ) {
                toast.error(error.response.data.message, {
                  position: toast.POSITION.TOP_RIGHT,
                });
              } else if (status === 500) {
                toast.error("Network Error, Check your internet conectivity.", {
                  position: toast.POSITION.TOP_RIGHT,
                });
              }
            }
          });
      } else {
        // If the last input is not filled, focus on the next input
        for (let i = 0; i < inputs.length; i++) {
          if (inputs[i].value && i < inputs.length - 1) {
            inputs[i + 1].focus();
          }
        }
      }
    }

    // Handle keydown events (e.g., backspace)
    function handleKeyDown(event) {
      const inputs = Array.from(
        otpInputContainer.getElementsByTagName("input")
      );
      const currentIndex = inputs.indexOf(event.target);

      if (
        event.key === "Backspace" &&
        currentIndex > 0 &&
        !event.target.value
      ) {
        // Focus on the previous input field if backspace is pressed and the current field is empty
        inputs[currentIndex - 1].focus();
      }
    }

    // #######################################not working but still here##########################################################

    // Set the countdown time in seconds
    const countdownTime = 5 * 60; // 5 minutes * 60 seconds

    // Get the timer element
    const timerElement = document.getElementById("count-down");

    // Function to update the timer display
    function updateTimerDisplay(timeInSeconds) {
      const minutes = Math.floor(timeInSeconds / 60);
      const seconds = timeInSeconds % 60;
      const formattedTime = `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
      timerElement.textContent = formattedTime;
    }

    // Function to perform an action when the countdown reaches 0
    function performAction() {
      $("#otp_modal").modal("hide");
    }

    // Function to start the countdown
    function startCountdown() {
      let timeRemaining = countdownTime;

      // Update the display initially
      updateTimerDisplay(timeRemaining);

      // Set an interval to update the countdown every second
      const countdownInterval = setInterval(function () {
        timeRemaining--;

        // Update the display
        updateTimerDisplay(timeRemaining);

        // Check if the countdown reached 0
        if (timeRemaining <= 0) {
          // Clear the interval
          clearInterval(countdownInterval);

          // Perform the action when the countdown reaches 0
          performAction();
        }
      }, 1000); // Update every 1000 milliseconds (1 second)
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.otp_cont {
  font-family: Arial, sans-serif;
  background-color: #f4f4f4;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.otp-input-container {
  width: 100%;
}
.otp-input {
  border-radius: 6px;
  border: 1px solid #00afef;
}

.otp-input:focus {
  outline: none;
  border: 3px solid #00afef;
}
.modal-dialog {
  width: 40%;
}
.special-color {
  color: #00afef;
}
p,
.count-down {
  font-weight: bold;
}
.xvx {
  display: none;
}
#errormsg {
  color: red;
  text-align: center;
  font-weight: bold;
  font-size: 17px;
}
</style>
